import { useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "sonner";
import { institutionalApi } from "api/institutional";
import { useDispatch, useSelector } from "react-redux";
import { getPath } from "api/customFetchBase";
import { AuthState } from "app/slices/authSlice";

export const useDocumentUpload = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const [uploadingDocument, setUploadingDocument] = useState<string | null>(
    null,
  );

  const { token } = useSelector<any, AuthState>((state) => state.auth);

  const handleDocumentUpload = async ({
    text_submission,
    destination_account_id,
    document_title,
    document_description,
    document_type,
    language,
    files,
    callback,
  }: {
    files: File[] | null;
    text_submission?: string;
    destination_account_id: string;
    document_title: string;
    document_description: string;
    document_type: string;
    language: string;
    callback?: () => void;
  }) => {
    // Require at least one of file or text
    if ((!files || files.length === 0) && !text_submission?.trim()) {
      toast.error(t("Please provide either a file or text submission"));
      return;
    }

    try {
      setUploadingDocument(document_title);
      const formData = new FormData();
      formData.append("destination_account_id", destination_account_id);
      formData.append("document_title", document_title);
      formData.append("document_description", document_description);
      formData.append("document_type", document_type);
      formData.append("language", language);

      if (files && files.length > 0) {
        formData.append("file", files[0]);
      }

      if (text_submission) {
        formData.append("text_submission", text_submission.trim());
      }

      const response = await fetch(
        `${getPath("institutional")}/router/bank_account/document_upload`,
        {
          method: "POST",
          body: formData,
          headers: {
            Authorization: token,
          },
        },
      );

      if (!response.ok) throw Error(t("Submission failed"));

      dispatch(institutionalApi.util.invalidateTags(["RouterAccounts"]));

      toast.success(t("Submitted successfully"));
      callback?.();
    } catch (e: any) {
      console.error(e);
      toast.error(e.message as string);
    } finally {
      setUploadingDocument(null);
    }
  };

  return {
    uploadingDocument,
    handleDocumentUpload,
  };
};
